"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.init = init;

var _whatwgFetch = require("whatwg-fetch");

var query = "query countries($locale: SupportedLocale!) {" + "  countries(locale: $locale) {" + "    name" + "    code" + "    labels {" + "      address1" + "      address2" + "      city" + "      company" + "      country" + "      firstName" + "      lastName" + "      phone" + "      postalCode" + "      zone" + "    }" + "    formatting {" + "      edit" + "    }" + "    zones {" + "      name" + "      code" + "    }" + "  }" + "}";
var GRAPHQL_ENDPOINT = 'https://country-service.shopifycloud.com/graphql';

function init() {
  if (document.querySelector('[data-countries]')) {
    loadCountries("EN").then(function (countries) {
      populateCountries(countries);
    });
  }
}

function loadCountries() {
  var response = (0, _whatwgFetch.fetch)(GRAPHQL_ENDPOINT, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'Access-Control-Allow-Origin': '*'
    },
    body: JSON.stringify({
      query: query,
      operationName: 'countries',
      variables: {
        locale: "EN"
      }
    })
  });

  return response.then(function (res) {
    return res.json();
  }).then(function (countries) {
    return countries.data.countries;
  });
}

function populateCountries(countries) {
  var countrySelect = document.querySelector('[data-countries]');
  var duplicatedCountrySelect = countrySelect.cloneNode(true);
  countrySelect.dataset.default = "US";

  countries.forEach(function (country) {
    var optionElement = document.createElement('option');
    optionElement.value = country.code;
    optionElement.textContent = country.name;
    duplicatedCountrySelect.appendChild(optionElement);
  });

  countrySelect.innerHTML = duplicatedCountrySelect.innerHTML;

  if (countrySelect.dataset.default) {
    countrySelect.value = countrySelect.dataset.default;
  }
}